module.exports = __webpack_public_path__ + "img/bumpMap_8192.8e470d56.jpg";